import { fetchWrapper } from '@/helpers/fetch-wrapper';
import { defineStore } from 'pinia';
import { ref } from 'vue';

const baseUrl = `${process.env.VUE_APP_SERVER_URL}/api/player/me`;

export const useUsersStore = defineStore('users', () => {
    const player = ref(JSON.parse(localStorage.getItem("player")) || {});
    async function authCheck() {
        try {
            const response = await fetchWrapper.get(baseUrl);
            if (response.player) {
                player.value = response.player;
                localStorage.setItem("player", JSON.stringify(response.player));
            }
        } catch (error) {
            console.error("Auth Check Error:", error);
            this.user = null;
        }
    }
    async function updateProfile(updatedData) {
        try {
            const response = await fetchWrapper.put(`${baseUrl}`, updatedData);
            if (response.player) {
                player.value = response.player;
                localStorage.setItem("player", JSON.stringify(response));
            }
            return response;
        } catch (error) {
            console.error("Update Profile Error:", error);
            throw error;
        }
    }
    return {
        player,
        authCheck,
        updateProfile,
    }
});